import { Pipe, PipeTransform } from '@angular/core';
import { CropService } from './../../common/_services/crop.service';

@Pipe({
  name: 'sumsizecrop',
  pure: true,
  standalone: false,
})
export class SumsizecropPipe implements PipeTransform {
  constructor(private cropService: CropService) {}

  transform(value: Array<number>): number {
    if (!value || value === undefined) {
      return null;
    }

    const selected = this.cropService.getCropSizeByMultipleId(value);
    if (selected) {
      return selected;
    } else {
      return null;
    }
  }
}
